import { Controller } from "@hotwired/stimulus"

// Adds rows to a grid form (issue lines, snapshot holdings) by cloning a
// <template>. The template's NEW_ROW placeholder becomes a unique index so
// each row's fields post as their own hash.
export default class extends Controller {
  static targets = ["template", "container"]

  add(event) {
    event.preventDefault()
    const html = this.templateTarget.innerHTML.replace(/NEW_ROW/g, `${Date.now()}`)
    this.containerTarget.insertAdjacentHTML("beforeend", html)
  }

  remove(event) {
    event.preventDefault()
    event.target.closest("[data-rows-item]")?.remove()
  }
}
